var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18909 0.160156H15.7992C17.7392 1.91016 19.5492 3.8502 21.4092 5.7002L21.5492 6.18018V23.2802C21.4192 25.0002 20.3391 26.2902 18.6091 26.5402H3.24915C1.50915 26.2302 0.479141 24.9702 0.369141 23.2302V3.40021C0.489141 1.71021 1.52911 0.470156 3.20911 0.160156H3.18909ZM14.9092 1.44019H3.35913C2.67913 1.44019 1.72912 2.4402 1.71912 3.1402V23.4602C1.80912 24.4102 2.58918 25.1502 3.53918 25.2302H18.3491C19.0491 25.2902 20.1792 24.3202 20.1792 23.6502V6.71021H15.3792C15.2592 6.71021 14.9192 6.35018 14.9192 6.25018V1.4502L14.9092 1.44019ZM19.2491 5.41016L16.2091 2.44019V5.41016H19.2491Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6499 11.6604L6.82983 14.4504C6.04983 15.0204 5.30987 14.2404 5.86987 13.4904C7.17987 12.3904 8.38983 10.6904 9.70983 9.65044C9.95983 9.46044 10.1699 9.28039 10.5099 9.41039L14.7899 13.6104C15.1399 14.1904 14.6799 14.7704 14.0299 14.6204L10.9498 11.6604V20.7404C10.9498 20.9904 10.5399 21.2604 10.2999 21.2704C10.0799 21.2704 9.6499 21.0304 9.6499 20.8004V11.6604Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.ca15c1f3a1a0cd1f29fddfe9cc61bb09.svg";
export { ForwardRef as ReactComponent };